import { render, staticRenderFns } from "./App.vue?vue&type=template&id=20646264"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=20646264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../Users/florent.sirigu/AppData/Roaming/nvm/v20.13.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports